import React from 'react'
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import currencyFormatter from 'currency-formatter'
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

toast.configure()

const Cart = () => {

    const removeCart = () => {
        toast.warn("The product have been removed",{
            position:toast.POSITION.TOP_CENTER
        })
    }
    
const {addedProducts,totalQuantity,totalPrice} =  useSelector(state => state.chosenProducts)
const {allFavouriteItems,favTotalQuantity,favTotalPrice} =  useSelector(state => state.favouriteProducts)
const dispatch = useDispatch()
return (
    <div className="cart">
        <div className="container">
        {
            addedProducts.length > 0 || allFavouriteItems.length>0?
            <>
            <div className="row">
                <div className="col-md-12 col-sm-12">
                    <h2>your cart</h2>

            
            <div className="row">
                {
                    addedProducts.map(product=>(
                        <div className="col-md-12 col-sm-12" key={product.id}>
                        <div className="cart-content">
                            <div className="cart-img">
                                <img src={product.image} alt={product.title} />
                            </div>

                            <div className="cart-info">
                                <h4>{product.title}</h4>
                                <p>Price {currencyFormatter.format(product.price, { code: 'USD' })}</p>
                                <div className="counter">
                                    <span onClick={() => dispatch({type:"DEC_CART_PRO",id:product.id})}>-</span>
                                    <span>{product.quantity}</span>
                                    <span onClick={() => dispatch({type:"INC_CART_PRO",id:product.id})}>+</span>
                                </div>
                                <p>Total Price {currencyFormatter.format(product.price * product.quantity, { code: 'USD' })}</p>
                                <button className="btn btn-danger" onClick={()=>{
                             dispatch({type:'REMOVE_Cart', payload:product})
                             removeCart()
                        }
                            }><i className="fas fa-trash-alt"></i>Remove</button>

                            </div>
                        </div>
                      </div>
                    ))
                }
                </div>
                </div>

                <div className="col-md-6 col-sm-6">
                    <div className="summary">
                    <div className="cart-title">
                         <h4>Favourite products</h4>
                    </div>
                    <div className="summary-desc">
                    <p>Total Products <span>{favTotalQuantity}</span></p>
                    <p>Total Price <span>{currencyFormatter.format(favTotalPrice, { code: 'USD' })}</span></p>
                    <Link to="/favourite">Favourite</Link>
                    </div>
                    </div>
                </div>


                <div className="col-md-6 col-sm-6">
                    <div className="summary">
                    <div className="cart-title">
                         <h4>Cart Products</h4>
                    </div>
                    <div className="summary-desc">
                    <p>Total Products <span>{totalQuantity}</span></p>
                    <p>Total Price <span>{currencyFormatter.format(totalPrice, { code: 'USD' })}</span></p>
                    <button className="btn btn-primary">Check out</button>
                    </div>
                    </div>
                </div>

            </div>
           
              
            </>
            
            :<h2 className="empty">you have no products</h2>
        }
        </div>
    </div>
)
}

export default Cart
